import { createQuery } from "../../../../../util/graphql";
import CreateForgotPasswordRequest from "./CreateForgotPasswordRequest.graphql";

export const createForgotPasswordRequest = ({ endpoint, clientSlug, email }) =>
  createQuery(endpoint, clientSlug)(CreateForgotPasswordRequest, {
    email
  });
